import { previewLocation } from '../services/studentPreview';

const prefix = 'review-draft-recovery:';
const lifetime = 12 * 60 * 60 * 1000;

export function reviewRecoveryKey(userId: number | undefined, target: string, kind = 'review') {
  if (previewLocation()) return '';
  return userId ? `${prefix}${userId}:${target}:${kind}` : '';
}

export function readReviewRecovery<T>(key: string): T | null {
  if (!key) return null;
  try {
    const stored = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (stored?.expires > Date.now()) return stored.value as T;
    sessionStorage.removeItem(key);
  } catch { /* Recovery is best effort when browser storage is unavailable. */ }
  return null;
}

export function writeReviewRecovery(key: string, value: unknown) {
  if (!key) return false;
  try {
    if (value == null) sessionStorage.removeItem(key);
    else sessionStorage.setItem(key, JSON.stringify({ expires: Date.now() + lifetime, value }));
    return true;
  } catch { return false; /* Keep the editor usable when storage is unavailable. */ }
}

export function clearReviewRecovery() {
  try {
    Object.keys(sessionStorage).filter(key => key.startsWith(prefix)).forEach(key => sessionStorage.removeItem(key));
  } catch { /* Storage can be disabled. */ }
}
